// extracted by mini-css-extract-plugin
export default {"my10":"OfflinePage_my10__WqpJX","fsp7":"OfflinePage_fsp7__CxE7m","woffline":"OfflinePage_woffline__4OwNm"};